import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const CardLine = ({ width = 26, height = 26, fill = '#898C8E', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.6631 2.71875C20.6714 2.82128 21.4588 3.67271 21.459 4.70801V21.291L21.4482 21.4961C21.3525 22.4372 20.6041 23.1856 19.6631 23.2812L19.459 23.291H8.29199L8.08789 23.2812C7.14652 23.1858 6.39847 22.4374 6.30273 21.4961L6.29199 21.291V4.70801C6.29216 3.6725 7.07932 2.821 8.08789 2.71875L8.29199 2.70801H19.459L19.6631 2.71875ZM8.29199 4.20801C8.01596 4.20801 7.79217 4.43201 7.79199 4.70801V21.291C7.79199 21.5672 8.01585 21.791 8.29199 21.791H19.459C19.7348 21.7907 19.959 21.5669 19.959 21.291V4.70801C19.9588 4.46664 19.7872 4.2645 19.5596 4.21777L19.459 4.20801H8.29199ZM15.542 7.04199C15.818 7.04217 16.042 7.26596 16.042 7.54199V10.333C16.042 10.609 15.818 10.8328 15.542 10.833H13.292C13.0158 10.833 12.792 10.6092 12.792 10.333V7.54199C12.792 7.26585 13.0158 7.04199 13.292 7.04199H15.542Z"
        fill={fill}
      />
    </Svg>
  );
};

export default CardLine;
